/**
 * Verification Dialog Constants
 *
 * This file contains all constants, enums, and magic numbers used in the
 * verification dialog component to improve maintainability and readability.
 */

// Treatment Types
export const TREATMENT_TYPES = {
  INDIVIDUAL: 'I',
  GROUP: 'G',
  DISCHARGE: 'D',
};

// Treatment Status IDs
// These IDs map to treatment status values in the database
export const TREATMENT_STATUS_IDS = {
  MEDICAL: 2,
  MISSED: 3,
  ATTENDED: 6,
  ADMIT_GROUP_OR_INDIVIDUAL: 15,
  NO_SHOW: 17,
  INDIVIDUAL_OR_RESIDENTIAL: 18,
  GROUP: 19,
};

// Validation Messages
export const VALIDATION_MESSAGES = {
  MAX_WEEK_UNITS: 'You have exceeded the Maximum allowable units per week for this Authorization.',
  MAX_INDIVIDUAL_UNITS: 'You have exceeded the Maximum allowable Individual treatments per week.',
  MAX_GROUP_UNITS: 'You have exceeded the Maximum allowable Group treatments per week.',
  SAVE_SUCCESS: 'Save Success.',
  SAME_DAY_TREATMENT: 'Treatments were not accepted because the participant cannot have both Individual and a Group treatment on the same day.',
};

// Dialog Types
export const DIALOG_TYPES = {
  INDIVIDUAL_OR_GROUP: 'Day',
  DISCHARGE: 'Dch',
};

// Days of the week configuration
export const WEEK_DAYS = [
  { name: 'Monday', shortName: 'Mon', offset: 0, index: 1 },
  { name: 'Tuesday', shortName: 'Tue', offset: 1, index: 2 },
  { name: 'Wednesday', shortName: 'Wed', offset: 2, index: 3 },
  { name: 'Thursday', shortName: 'Thu', offset: 3, index: 4 },
  { name: 'Friday', shortName: 'Fri', offset: 4, index: 5 },
  { name: 'Saturday', shortName: 'Sat', offset: 5, index: 6 },
  { name: 'Sunday', shortName: 'Sun', offset: 6, index: 7 },
];

// Treatment field mapping for validation
export const TREATMENT_FIELDS = [
  { field: 'i1TmtTmtStsId', type: TREATMENT_TYPES.INDIVIDUAL, dayIndex: 0 },
  { field: 'i2TmtTmtStsId', type: TREATMENT_TYPES.INDIVIDUAL, dayIndex: 1 },
  { field: 'i3TmtTmtStsId', type: TREATMENT_TYPES.INDIVIDUAL, dayIndex: 2 },
  { field: 'i4TmtTmtStsId', type: TREATMENT_TYPES.INDIVIDUAL, dayIndex: 3 },
  { field: 'i5TmtTmtStsId', type: TREATMENT_TYPES.INDIVIDUAL, dayIndex: 4 },
  { field: 'i6TmtTmtStsId', type: TREATMENT_TYPES.INDIVIDUAL, dayIndex: 5 },
  { field: 'i7TmtTmtStsId', type: TREATMENT_TYPES.INDIVIDUAL, dayIndex: 6 },
  { field: 'g1TmtTmtStsId', type: TREATMENT_TYPES.GROUP, dayIndex: 0 },
  { field: 'g2TmtTmtStsId', type: TREATMENT_TYPES.GROUP, dayIndex: 1 },
  { field: 'g3TmtTmtStsId', type: TREATMENT_TYPES.GROUP, dayIndex: 2 },
  { field: 'g4TmtTmtStsId', type: TREATMENT_TYPES.GROUP, dayIndex: 3 },
  { field: 'g5TmtTmtStsId', type: TREATMENT_TYPES.GROUP, dayIndex: 4 },
  { field: 'g6TmtTmtStsId', type: TREATMENT_TYPES.GROUP, dayIndex: 5 },
  { field: 'g7TmtTmtStsId', type: TREATMENT_TYPES.GROUP, dayIndex: 6 },
  { field: 'd1TmtTmtStsId', type: TREATMENT_TYPES.DISCHARGE, dayIndex: 0 },
  { field: 'd2TmtTmtStsId', type: TREATMENT_TYPES.DISCHARGE, dayIndex: 1 },
  { field: 'd3TmtTmtStsId', type: TREATMENT_TYPES.DISCHARGE, dayIndex: 2 },
  { field: 'd4TmtTmtStsId', type: TREATMENT_TYPES.DISCHARGE, dayIndex: 3 },
  { field: 'd5TmtTmtStsId', type: TREATMENT_TYPES.DISCHARGE, dayIndex: 4 },
  { field: 'd6TmtTmtStsId', type: TREATMENT_TYPES.DISCHARGE, dayIndex: 5 },
  { field: 'd7TmtTmtStsId', type: TREATMENT_TYPES.DISCHARGE, dayIndex: 6 },
];

// Status IDs that count towards week units
export const COUNTABLE_STATUS_IDS = [
  TREATMENT_STATUS_IDS.INDIVIDUAL_OR_RESIDENTIAL,
  TREATMENT_STATUS_IDS.GROUP,
  TREATMENT_STATUS_IDS.ADMIT_GROUP_OR_INDIVIDUAL,
];

// Status IDs that trigger admit/group dropdown
export const ADMIT_GROUP_STATUS_IDS = [
  TREATMENT_STATUS_IDS.ADMIT_GROUP_OR_INDIVIDUAL,
  TREATMENT_STATUS_IDS.NO_SHOW,
];

// Status IDs that trigger medical/missed dropdown
export const MEDICAL_MISSED_STATUS_IDS = [
  TREATMENT_STATUS_IDS.INDIVIDUAL_OR_RESIDENTIAL,
  TREATMENT_STATUS_IDS.MEDICAL,
  TREATMENT_STATUS_IDS.ATTENDED,
  TREATMENT_STATUS_IDS.MISSED,
];
